import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Container, Typography } from '@material-ui/core';
import "../styles/partials/cane.scss";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(7),
        minWidth: 180,
        textAlign: 'center',
        color: '#f6f4f4',
        backgroundColor:'#d05454',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    timeLeft: {
        textAlign: 'center',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#121010',
        fontFamily: '"Comic Sans MS", cursive, sans-serif',
    },
    timeLabel: {
        textAlign: 'center',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        color: '#ece2e2',
        fontFamily: '"Comic Sans MS", cursive, sans-serif',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    selectedOption: {
        fontWeight: 'bold',
    },
}));function Countdown() {
    const classes = useStyles();
    const [timeZone, setTimeZone] = React.useState('');
    const [timeLeft, setTimeLeft] = React.useState(null);

    const handleChange = (event) => {
        setTimeZone(event.target.value);
    };

   useEffect(() => {
        const interval = setInterval(() => {
            const currentTime = new Date();
            const newYearEve = new Date(`December 31, ${currentTime.getFullYear()} 23:59:59`);
            let timeLeft = newYearEve - currentTime;
            if (timeZone) {
                timeLeft += new Date().getTimezoneOffset() * 60 * 1000;
                timeLeft -= timeZone * 60 * 60 * 1000;
            }
            setTimeLeft(timeLeft);
        }, 1000);
        return () => clearInterval(interval);
    }, [timeZone]);

    return (
        <Container className={classes.container}>
            <Typography className={classes.timeLabel}>
                Time left until New Year's Eve:
            </Typography>
            {timeLeft ? (
                <Typography className={classes.timeLeft}>
                    {Math.floor(timeLeft / (1000 * 60 * 60 * 24))} days {Math.floor(timeLeft / (1000 * 60 * 60)) % 24} hours{' '}
                    {Math.floor(timeLeft / (1000 * 60)) % 60} minutes {Math.floor(timeLeft / 1000) % 60} seconds
                </Typography>
            ) : (
                'Loading...'
            )}
            <FormControl className={classes.formControl}>
                <InputLabel id="time-zone-label"> Choose a Time Zone</InputLabel>
                <Select
                    labelId="time-zone-label"
                    id="time-zone-select"
                    value={timeZone}
                    onChange={handleChange}
                >
                    <MenuItem value={-6}>Central Standard Time (CST)</MenuItem>
                    <MenuItem value={-5}>Central European Time (CET)</MenuItem>
                    <MenuItem value={-4}>Eastern European Time (EET)</MenuItem>
                    <MenuItem value={-3}>Eastern Standard Time (EST)</MenuItem>
                    <MenuItem value={0}>Coordinated Universal Time (UTC)</MenuItem>
                </Select>
            </FormControl>
        </Container>
    );
}

export default Countdown;

